/**
 * Stone Investment Property Location
 *
 * Stone-themed wrapper for the core PropertyLocation component.
 * Applies Cormorant Garamond headings and square-corner aesthetic.
 */

'use client';

import { PropertyLocation, type PropertyLocationProps } from '@/components/properties';

export type StonePropertyLocationProps = PropertyLocationProps;

export function StonePropertyLocation(props: PropertyLocationProps) {
  return (
    <div
      className="
        relative
        font-['Montserrat',-apple-system,BlinkMacSystemFont,'Segoe_UI',sans-serif]
        [&_h2]:font-['Cormorant_Garamond','Georgia',serif]
        [&_h3]:font-['Cormorant_Garamond','Georgia',serif]
        **:rounded-none
      "
    >
      <PropertyLocation {...props} className="" />
    </div>
  );
}
